/**
 * @file 更多玩儿法
 * @description 返回到主页
 */
<template>
    <div
        class="back-main"
        :style="{'top': top + 'px'}"
        @click.stop="backMain"
    >
    </div>
</template>

<script>
export default {
    props: {
        top: {
            type: Number,
            default: 0
        }
    },

    methods: {
        backMain() {
            this.$router.push({
                path: '/',
                query: Object.assign(this.$route.query, {pageType: 'main'})
            });
        }
    }
};

</script>

<style lang='scss' scoped>
    .back-main {
        position: fixed;
        top: 0;
        width: 70px;
        height: 30px;
        background: url(../assets/v4/common/more-model.png) no-repeat;
        background-size: 100% 100%;
        z-index: 10;
    }
</style>
